import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../auth/api";
import { alertSuccess, alertError } from "../components/Alert";
import { Satellite } from "lucide-react";


// Fetch Help Support Open Queries
export const fetchHelpSupportOpenQuery = createAsyncThunk(
  "helpSupportOpenQuery/fetchHelpSupportOpenQuery",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { page = 1, page_size = 10, in_progress = "", is_resolve = "", search = "" } = params;
      let url = `/HelpSupport/panel/HelpOpen?page=${page}&page_size=${page_size}`;
      if (in_progress !== "") {
        url += `&in_progress=${in_progress}`;
      }
      if (is_resolve !== "") {
        url += `&is_resolve=${is_resolve}`;
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await api.get(url);
      return {
        data: response.data,
        page,
        pageSize: page_size,
        in_progress,
        is_resolve,
        search
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update Help Support Open Queries

export const UdateHelpSupportOpenQuery = createAsyncThunk(
    "helpSupportOpenQuery/updateHelpSupportOpenQuery" ,
    async (queryData , {rejectWithValue}) => {
        console.log(queryData)
       try{
          const response = await api.patch("/HelpSupport/panel/HelpOpen" ,queryData );
           alertSuccess(response.data.success);
          return response.data;
       }catch(error){
          alertError(error.response?.data?.errors)
          return rejectWithValue(error.response?.data.errors || error.message);
       }
    }

)

// Help Support Open Query Slice
const helpSupportOpenQuery = createSlice({
  name: "helpSupportOpenQuery",
  initialState: {
    helpSupportQueryData: { result: [], pagination: {} },
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    inProgressFilter: "",
    isResolveFilter: "",
    search: "",
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.currentPage = 1;
    },
    setFilters: (state, action) => {
      const { inProgressFilter, isResolveFilter, search } = action.payload;
      if (inProgressFilter !== undefined) state.inProgressFilter = inProgressFilter;
      if (isResolveFilter !== undefined) state.isResolveFilter = isResolveFilter;
      if (search !== undefined) state.search = search;
      state.currentPage = 1;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Help Support Open Queries
      .addCase(fetchHelpSupportOpenQuery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchHelpSupportOpenQuery.fulfilled, (state, action) => {
        state.status = "succeeded";
        const { data, page, pageSize, in_progress, is_resolve, search } = action.payload;
        state.helpSupportQueryData = data;
        state.currentPage = page;
        state.pageSize = pageSize;
        state.inProgressFilter = in_progress;
        state.isResolveFilter = is_resolve;
        state.search = search;

        const count = data?.pagination?.count || data?.pagination?.total_count || 0;
        state.totalPages = data?.pagination?.total_pages || Math.ceil(count / pageSize) || 1;
      })
      .addCase(fetchHelpSupportOpenQuery.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Help and Support Open Query
      .addCase(UdateHelpSupportOpenQuery.pending , (state) =>{
        state.status = "loading";
        state.error = null;
      })
      .addCase(UdateHelpSupportOpenQuery.fulfilled , (state) =>{
        state.status = "succeeded";
      })
      .addCase(UdateHelpSupportOpenQuery.rejected , (state , action) =>{
        state.status = "failed";
        state.error = action.payload;
      })
  },
});

export const { clearError, setPage, setPageSize, setFilters } = helpSupportOpenQuery.actions;
export default helpSupportOpenQuery.reducer;
